var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{ref:"selectElement",staticClass:"js-example-placeholder-multiple js-states form-control",staticStyle:{"width":"100%"},attrs:{"multiple":"multiple"}},_vm._l((_vm.customOptions),function(item,index){return _c('option',{key:index,domProps:{"value":item}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }